// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../node_modules/css-loader/index.js?minimize!../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0fb7dfed\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/less-loader/index.js!./main.less");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../node_modules/vue-loader/node_modules/vue-style-loader/lib/addStylesClient.js")("6993a3b8", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-0fb7dfed","scoped":false,"hasInlineConfig":false}!./~/less-loader!./src/main.less
// module id = 592
// module chunks = 0